// extracted by mini-css-extract-plugin
module.exports = {"Image":"SatisfacionEncuesta_Image__2Ntz0","card":"SatisfacionEncuesta_card__2-xQK","cardTitle":"SatisfacionEncuesta_cardTitle__XoV4Q","button":"SatisfacionEncuesta_button__2TyVi"};